import React, { useState, useEffect } from 'react';
import CurrencyInput from 'react-currency-input-field';
import api from '../../../../config/axios';
import Swal from 'sweetalert2';
import { FaTimes, FaRegSave } from 'react-icons/fa';
import DatePicker, { dateHelpers } from '../../../../components/utils/datepicker';

const CriarLancamento = ({ transacao, contaBancariaId, onClose, onSalvar }) => {

    const [formData, setFormData] = useState({
        tipo: transacao.tipo === 'credito' ? 'receita' : 'despesa',
        categoria_id: '',
        valor: Math.abs(transacao.valor).toString().replace('.', ','),
        data_vencimento: transacao.data_transacao,
        data_competencia: transacao.data_transacao,
        data_lancamento: new Date().toLocaleDateString('pt-BR'),
        centro_custo_id: '',
        descricao: transacao.descricao_original || '',
        observacao: `Criado a partir da conciliação bancária - Transação: ${transacao.descricao_original}`
    });

    const [categorias, setCategorias] = useState([]);
    const [centrosCusto, setCentrosCusto] = useState([]);

    useEffect(() => {
        fetchCategorias(formData.tipo);
        fetchCentrosCusto();
    }, []);

    const fetchCategorias = async (tipo) => {
        try {
            const userData = JSON.parse(localStorage.getItem('userData') || '{}');
            const tipoVinculo = userData.unidade_designacao_id ? 'unidade' : 'gestora';
            const tipoFiltro = tipo === 'receita' ? 'receita' : 'despesa';

            const response = await api.get(`/categorias-financeiras?limit=200&tipo_financeiro=${tipoFiltro}&tipo_vinculo=${tipoVinculo}`);
            setCategorias(response.data.records || []);
        } catch (error) {
            setCategorias([]);
        }
    };

    const fetchCentrosCusto = async () => {
        try {
            const response = await api.get('/centros-de-custo?limit=200');
            setCentrosCusto(response.data.records || []);
        } catch (error) {
            setCentrosCusto([]);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleTipoChange = (e) => {
        const tipo = e.target.value;
        setFormData(prev => ({
            ...prev,
            tipo: tipo,
            categoria_id: ''
        }));
        fetchCategorias(tipo);
    };

    const convertToISO = (dateString) => {
        if (!dateString) return '';
        if (dateString.includes('-') && !dateString.includes('/')) return dateString;
        if (dateString.length !== 10) return dateString;
        const [dia, mes, ano] = dateString.split('/');
        return `${ano}-${mes}-${dia}`;
    };

    const handleSubmit = async () => {
        const valorNumerico = parseFloat(formData.valor.replace(/\./g, '').replace(',', '.'));

        if (!formData.valor || valorNumerico <= 0) {
            Swal.fire('Erro', 'O valor deve ser maior que zero', 'error');
            return;
        }

        if (!formData.categoria_id) {
            Swal.fire('Erro', 'Selecione uma categoria', 'error');
            return;
        }

        if (!formData.data_vencimento) {
            Swal.fire('Erro', 'A data de vencimento é obrigatória', 'error');
            return;
        }

        if (formData.tipo === 'despesa' && !formData.centro_custo_id) {
            Swal.fire('Erro', 'Selecione um centro de custo', 'error');
            return;
        }

        try {
            Swal.fire({
                title: 'Criando lançamento...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const dadosLancamento = {
                categoria_id: parseInt(formData.categoria_id),
                valor: valorNumerico,
                data_vencimento: convertToISO(formData.data_vencimento),
                data_competencia: convertToISO(formData.data_competencia) || convertToISO(formData.data_vencimento),
                data_lancamento: convertToISO(formData.data_lancamento),
                centro_custo_id: formData.centro_custo_id ? parseInt(formData.centro_custo_id) : null,
                descricao: formData.descricao || null,
                observacao: formData.observacao || null,
                conta_bancaria_id: contaBancariaId
            };

            await api.post(`/conciliacao/transacao/${transacao.id}/criar-lancamento`, {
                dados_lancamento: dadosLancamento
            });

            Swal.fire('Sucesso', 'Lançamento criado e conciliado com sucesso', 'success');
            onSalvar();

        } catch (error) {
            Swal.fire('Erro', error.response?.data?.message || 'Erro ao criar lançamento', 'error');
        }
    };

    const formatarData = (dataString) => {
        if (!dataString) return '';
        if (dataString.includes('/')) return dataString;
        if (dataString.includes('-')) {
            const [ano, mes, dia] = dataString.split('-');
            return `${dia}/${mes}/${ano}`;
        }
        return dataString;
    };

    const formatarValor = (valor) => {
        if (!valor) return 'R$ 0,00';
        return parseFloat(valor).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Criar Lançamento</h4>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="card info-card mb-3">
                            <div className="card-body p-3">
                                <p className="mb-1">
                                    <strong>Descrição:</strong> {transacao.descricao_original}
                                </p>
                                <p className="mb-1">
                                    <strong>Data:</strong> {formatarData(transacao.data_transacao)} | <strong>Valor:</strong> {transacao.tipo === 'debito' ? '-' : ''}{formatarValor(Math.abs(transacao.valor))}
                                </p>
                                <div className="alert alert-info mb-0 mt-2 py-2">
                                    <p>Um novo lançamento será criado e automaticamente conciliado com esta transação do extrato.</p>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-4 col-12">
                                <label className="form-label fw-bold">Tipo</label>
                                <select
                                    className="form-select"
                                    name="tipo"
                                    value={formData.tipo}
                                    onChange={handleTipoChange}
                                    disabled
                                >
                                    <option value="receita">Receita</option>
                                    <option value="despesa">Despesa</option>
                                </select>
                            </div>
                            <div className="col-lg-4 col-12 mt-3 mt-lg-0">
                                <label className="form-label fw-bold">Valor</label>
                                <CurrencyInput
                                    name="valor"
                                    placeholder="R$ 0,00"
                                    value={formData.valor}
                                    decimalsLimit={2}
                                    decimalSeparator=","
                                    groupSeparator="."
                                    prefix="R$ "
                                    className="form-control"
                                    autoComplete="off"
                                    disabled
                                    onValueChange={(value) => {
                                        setFormData(prev => ({
                                            ...prev,
                                            valor: value || ''
                                        }));
                                    }}
                                />
                            </div>
                            <div className="col-lg-4 col-12 mt-3 mt-lg-0">
                                <label className="form-label fw-bold">Categoria</label>
                                <select
                                    className="form-select"
                                    name="categoria_id"
                                    value={formData.categoria_id}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Selecione...</option>
                                    {categorias.map(categoria => (
                                        <option key={categoria.id} value={categoria.id}>
                                            {categoria.nome}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-lg-4 col-12">
                                <label className="form-label fw-bold">Data de Vencimento</label>
                                <DatePicker
                                    selected={dateHelpers.stringToDate(formatarData(formData.data_vencimento))}
                                    onChange={dateHelpers.createOnChangeHandler((date) => {
                                        setFormData(prev => ({
                                            ...prev,
                                            data_vencimento: date
                                        }));
                                    })}
                                />
                            </div>
                            <div className="col-lg-4 col-12 mt-3 mt-lg-0">
                                <label className="form-label fw-bold">Data de Competência</label>
                                <DatePicker
                                    selected={dateHelpers.stringToDate(formatarData(formData.data_competencia))}
                                    onChange={dateHelpers.createOnChangeHandler((date) => {
                                        setFormData(prev => ({
                                            ...prev,
                                            data_competencia: date
                                        }));
                                    })}
                                />
                            </div>
                            <div className="col-lg-4 col-12 mt-3 mt-lg-0">
                                <label className="form-label fw-bold">Centro de Custo</label>
                                <select
                                    className="form-select"
                                    name="centro_custo_id"
                                    value={formData.centro_custo_id}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Selecione...</option>
                                    {centrosCusto.map(centro => (
                                        <option key={centro.id} value={centro.id}>
                                            {centro.nome}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-12">
                                <label className="form-label fw-bold">Descrição</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="descricao"
                                    value={formData.descricao}
                                    autoComplete="off"
                                    maxLength={500}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-12">
                                <label className="form-label fw-bold">Observações</label>
                                <textarea
                                    className="form-control"
                                    rows={4}
                                    name="observacao"
                                    value={formData.observacao}
                                    autoComplete="off"
                                    maxLength={1000}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-danger" onClick={onClose}>
                            <FaTimes className="me-1" />
                            Fechar
                        </button>
                        <button type="button" className="btn btn-custom-primary" onClick={handleSubmit}>
                            <FaRegSave className="me-1" />
                            Criar e Conciliar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CriarLancamento;
